import React, { useState, useEffect } from "react";
import "./select.css";
import lupa from "../../icons/icon_lupa.svg"

const SelectOptionEl = ({ el }) => {
  if (typeof el === "object") {
    return <>
      {[el].map((item) => {
        let keys = Object.keys(item);
        return keys.map((key, index) => {
          if (key === "image") {
            return <span key={index}><img src={item[key]} /></span>
          }
          if (key === "value") {
            return <input key={index} type="hidden" value={item[key]} />;
          }
          return <span key={index}>{item[key]}</span>;
        });
      })}
    </>
  }
  return <></>
}

const Select = ({ search = true, required = "", autofocus = false, onBlur = null, placeholder = "Select your option", name = "", id = "", value = "", options = [], onChange = null, handleChange = null }) => {
  const [input, setInput] = useState("");
  const [tempInput, setTempInput] = useState("");
  const [tempOptions, setTempOptions] = useState(options);
  const [selectOpen, setSelectOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (options !== null && options.length > 0 && value !== "") {
      options.map(option => {
        if (option.value === value) {
          setInput(option.text);
        }
      });
      setTempOptions(options);
      if (options !== null && options.length > 0 && !loaded) {
        setLoaded(true);
        setTempOptions(options);
      }
    }
  }, [value]);

  useEffect(() => {
    if (input !== "") {
      selectFilter();
    }
  }, [input])

  const handleChangeSelect = (value) => {
    if (typeof handleChange === "function" && value !== undefined && value !== "") {
      handleChange(value, input);
    }
    if (typeof onChange === 'function' && value !== undefined && value !== "") {
      onChange(value, input);
    }
  };

  const selectFilter = () => {
    if (input === undefined) {
      return;
    }
    if (input.length === 0) {
      setTempOptions(options);
      return;
    }
    let newOptions = [];
    options.map((el) => {
      if (el !== undefined) {
        if (typeof el === "object") {
          let keys = Object.keys(el);
          let filter = [];
          keys.map((key, index) => {
            if (key === "image") {
              return;
            }
            filter.push(key);
          });
          let inp = input;
          filter.forEach((f) => {
            if ((typeof el[f] === "string" && (el[f].includes(inp.toLowerCase()) || el[f].toLowerCase().includes(inp.toLowerCase()) || el[f].toUpperCase().includes(inp.toLowerCase())) && !newOptions.includes(el))) {
              newOptions.push(el);
              return;
            }
          })
          return;
        }
        let inp = input;
        if (el.includes(inp.toLowerCase()) || el.toLowerCase().includes(inp.toLowerCase()) || el.toUpperCase().includes(inp.toLowerCase())) {
          newOptions.push(el);
        }
      }
    });
    if (newOptions.length === 0) {
      newOptions = [";-("];
    }
    setTempOptions(newOptions);
  };

  const handleInput = (e) => {
    switch (e.type) {
      case "focus":
        setSelectOpen(true);
        break;
      case "click":
        e.stopPropagation();
        setSelectOpen(!selectOpen);
        setTempOptions(options);
        break;
      case "change":
      case "keyup":
        if (search) {
          setSelectOpen(true);
          setInput(e.target.value);
        }
        break;
      case "blur":
        setSelectOpen(false);
        if (typeof onBlur === "function") {
          handleChangeSelect(tempInput);
          onBlur(e);
        }
        break;
    }
  };

  const handleOption = (e) => {
    let target = e.target;
    if (target.tagName === "SPAN") {
      target = target.parentNode;
    }
    if (target.querySelector("input") !== null) {
      let value = target.querySelector("input").value;
      if (e.target.innerText !== ";-(") {
        setSelectOpen(false);
        setInput(e.target.innerText);
        handleChangeSelect(value);
      }
    }
  };

  if (options === null || (options !== null && options.length === 0)) {
    return <></>
  }

  return <label className={"agendamento-input select-component " + (selectOpen ? "select-dropdown-open" : "")} htmlFor={id}>
    <img src={lupa} alt="icone-lupa" />
    <input name={name} type="hidden" value={value || ""} />
    <input
      autoFocus={autofocus}
      onClick={handleInput}
      onChange={handleInput}
      onKeyUp={handleInput}
      onBlur={handleInput}
      data-required={required}
      type="text"
      value={input || ""}
      placeholder={placeholder}
    />
    <div className="select-dropdown">
      {tempOptions !== null ? tempOptions.map((el, key) => {
        return <div onMouseEnter={() => setTempInput(el.value)} onClick={handleOption} key={key}><SelectOptionEl el={el} /></div>
      }) : <></>}
    </div>
  </label>
};

export default Select;
